<template lang="pug">
    #status
        p
        | {{$store.getters.getScroll}}
</template>
<script>
export default {
    name: "status"
};
</script>
<style lang="scss" scoped>
#status {
    background: #fff;
    padding: 3.2rem;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0.5;
    z-index: 10;
}
</style>
